<script>
export default {

    name: 'simple-panel',

    props: {
        heading: Boolean,
        footer: Boolean,
    },

}
</script>

<template lang="html">

    <div class="simple-panel">

        <div v-if="heading" class="simple-panel-header">
            <slot name="heading"></slot>
        </div>

        <div class="simple-panel-body">
            <slot></slot>
        </div>

        <div v-if="footer" class="simple-panel-footer">
            <slot name="footer"></slot>
        </div>
    </div>

</template>



// WEBPACK FOOTER //
// src/components/elements/simplePanel.vue